// App.js
import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import SolutionDetail from './pages/Solutions/SolutionDetail';
import ResourcesIndex from './pages/Resources/ResourcesIndex';
import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />
          <Route path="/resources" element={<ResourcesIndex />} />
          {/* Fallback to Home page if route is unknown */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;